import React from 'react';
import { useLocation } from 'react-router-dom';
import { RemainingLeavesShared } from '../shared/LeaveComponents';
import { getRemainingLeaves } from './redux.actions';

const RemainingLeaves = ({ year }) => {
    const { state: { email } } = useLocation();

    return (
        <RemainingLeavesShared 
            year={year}
            title={`Leaves Summary for ${email}`}
            fetchAction={getRemainingLeaves}
            actionPayload={{ email }}
        />
    );
};

export default RemainingLeaves;
